<ng-container *ngIf="!isBdOnly" [caLocalizationScope]="localizationScope">
  <i
    class="f-i text-muted"
    [class]="getIconClass()"
    [ngClass]="[iconClass, iconSizeClass]"
    [ngbTooltip]="tooltipContent"
    [container]="container"
    data-automation-id="bd-crm-profiles-icon"
  >
  </i>
  <ng-template #tooltipContent>
    <span>{{ getIconTitle() | caLocalize }}</span>
  </ng-template>
</ng-container>
